import { default as module } from './AbstractModule';

export default class extends module {
    constructor(m) {
        super(m);

        this.slider = this.$('slider')
    }

    init() {
        this.swiper = new Swiper(this.slider, {
            grabCursor: true,
            slideToClickedSlide: true
        })
    }

    destroy() {
        this.swiper.destroy()
        this.swiper = null
    }
}
